<template>
  <div class="level">
    <svgicon
      name="filter"
      width="30"
      height="30"
      color="#63CCCA"
      :original="true"
      class="level-item filter-icon"
      :class="{ notselected: filterTags.length === 0 }">
    </svgicon>
    <div class="level-item">
      <drop-down-auto-complete
        title="Categories"
        label="Select a Category"
        :options="categories"
        v-on:dropdown-selection="addCatFilter($event.input)">
      </drop-down-auto-complete>
      <drop-down-auto-complete
        title="Actions"
        label="Select a Action"
        :options="actions"
        v-on:dropdown-selection="addActionFilter($event.input)">
      </drop-down-auto-complete>
      <drop-down-auto-complete
        title="Tags"
        label="Select a Tag"
        :options="tags"
        v-on:dropdown-selection="addTagFilter($event.input)">
      </drop-down-auto-complete>
    </div>
    <b-switch
      v-if="showDigitaSwitch"
      v-model="internalDigita"
      class="level-item">
      Show Digita Analytics
    </b-switch>
    <div class="tags level-item filter-tags">
      <span
        v-for="filter in filterTags"
        :key="filter"
        class="tag is-rounded">
        <span>{{ filter }}</span>
        <a @click="removeFilterTag(filter)" role="button" tabindex="0" class="delete is-small"></a>
      </span>
    </div>
  </div>
</template>

<script>
import DropDownAutoComplete from '@/components/DropDownAutoComplete.vue';

export default {
  name: 'AnalyticsFilterBar',
  components: { DropDownAutoComplete },
  props: {
    filter: {
      type: Array,
      required: true,
    },
    digita: {
      type: Boolean,
      required: true,
    },
    categories: {
      type: Array,
      required: true,
    },
    tags: {
      type: Array,
      required: true,
    },
    actions: {
      type: Array,
      required: true,
    },
    showDigitaSwitch: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      filterTags: [],
      internalDigita: this.digita,
    };
  },
  watch: {
    internalFilter() {
      // Only sending out the filterTags for this since it is not a backend query
      this.$emit('update:filter', this.filterTags);
    },
    internalDigita() {
      this.$emit('update:digita', this.internalDigita);
    },
  },
  computed: {
    internalFilter() {
      const filter = {
        filters: [],
        operator: 'and',
      };
      this.filterTags.forEach((f) => {
        const filterItem = f.split(':');
        if (filterItem[0] === 'tag') {
          filter.filters.push({
            tags: {
              any: [filterItem[1]],
              operator: 'and',
            },
          });
        } else if (filterItem[0] === 'version') {
          filter.filters.push({
            version: {
              eq: filterItem[1],
              operator: 'and',
            },
          });
        } else if (filterItem[0] === 'label') {
          filter.filters.push({
            label: {
              eq: filterItem[1],
              operator: 'and',
            },
          });
        }
      });
      if (Object.keys(filter.filters).length > 0) {
        return filter;
      }
      return filter;
    },
  },
  methods: {
    addTagFilter(tag) {
      const newTag = `tag:${tag}`;
      if (!this.filterTags.includes(newTag)) {
        this.filterTags.push(newTag);
      }
    },
    addCatFilter(cat) {
      const tag = `category:${cat}`;
      if (!this.filterTags.includes(tag)) {
        this.filterTags.push(tag);
      }
    },
    addActionFilter(action) {
      const tag = `action:${action}`;
      if (!this.filterTags.includes(tag)) {
        this.filterTags.push(tag);
      }
    },
    removeFilterTag(tag) {
      this.filterTags = this.filterTags.filter(t => t !== tag);
    },
  },
};
</script>

<style lang="scss" scoped>

.filter-tags {
  .tag {
    color: $main-background;
    background-color: $expression-background;
  }
}

/deep/ .switch {
  .control-label {
    color: $expression-background;
  }
}

.level-left .level-item:not(:last-child) {
  &.filter-icon {
    margin-right: 0;
    margin-left: 1rem;
  }
}
</style>
